if (!window.Eurus.loadedScript.includes('pagination.js')) {
  window.Eurus.loadedScript.push('pagination.js');

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xPagination", (sectionId) => ({
        loading: false,
        lastLoadTime: 0,
        debounceDelay: 500, // Prevent rapid-fire loading
        loadData(url) {
          // Debounce rapid scroll triggers
          const now = Date.now();
          if (now - this.lastLoadTime < this.debounceDelay && this.loading) {
            return;
          }
          this.lastLoadTime = now;
          
          this.loading = true
          fetch(url)
          .then(response => response.text())
          .then(response => {
            const parser = new DOMParser();
            const html = parser.parseFromString(response,'text/html');
            const productGrid = html.getElementById('items-grid');
            if (!productGrid) {
              this.loading = false;
              return;
            }
            const newProducts = productGrid.getElementsByClassName('grid-item');
            let productsOnPage = document.getElementById("items-grid");
            let blogGrid = document.getElementById("blog-grid");
            if (blogGrid) { productsOnPage = blogGrid }

            const appendedCards = [];
            const fragment = document.createDocumentFragment();

            for (let i = 0; i < newProducts.length; i++) {
              const gridItem = newProducts[i].cloneNode(true);
              appendedCards.push(gridItem);
              fragment.appendChild(gridItem);
            }

            productsOnPage.appendChild(fragment);

            requestAnimationFrame(() => {
              setTimeout(() => {
                document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
                if (typeof window.renderKlaviyoStarWidgets === 'function') {
                  window.renderKlaviyoStarWidgets();
                }
                this._renderButton(html);
                this.loading = false;
              }, 100);
            });
          })
          .catch(e => {
            console.error(e);
            this.loading = false;
          })
        } ,
        _renderButton(html) {
          const destination = document.getElementById('btn-pagination-' + sectionId);
          const source = html.getElementById('btn-pagination-' + sectionId);
          if (destination && source) {
            destination.innerHTML = source.innerHTML;
          }
        }
      }));
    });
  });
}
